import { useLocalStorageAsState } from "@msys/ui";
import { uniq } from "lodash-es";
import React from "react";
import type { CategoryWithMatchAndChildren } from "./helpers.js";

export const useCategoriesExpandedItems = (
  categoriesMap: Map<string, CategoryWithMatchAndChildren>,
  selectedCategoryIds: string[]
): ReturnType<typeof useLocalStorageAsState<string[]>> => {
  const initialized = React.useRef<boolean>(false);

  const [expandedItemIds, setExpandedItemIds] = useLocalStorageAsState<
    string[]
  >("msys-CategoriesSearchModal-expandedItems", [], false, {
    processOnGet: (value: string[]) => {
      if (initialized.current) return value;
      initialized.current = true;

      if (selectedCategoryIds.length === 0) return value;

      const parentCategoryIds: string[] = [];
      selectedCategoryIds.forEach(selectedCategoryId => {
        let currentCategory = categoriesMap.get(selectedCategoryId);
        do {
          if (currentCategory?.parentId) {
            parentCategoryIds.push(currentCategory.parentId);
            currentCategory = categoriesMap.get(currentCategory.parentId);
          }
        } while (currentCategory?.parentId);
      });

      return uniq([...value, ...parentCategoryIds]);
    },
  });

  return [expandedItemIds, setExpandedItemIds];
};
